
import Brand from '~/pages/_lang/brand/_keyword'
export default Brand
